import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Button } from 'Components/frameworks/button/Button';
import { Modal } from 'Components/frameworks/modal/Modal';
type EditMyCriteriaPopinPropsType = {
  onCloseModal: () => void;
  onClickCancel?: () => void;
  onClickConfirm: () => void;
  mainIconName: string;
  cancelLabel?: string;
  confirmLabel: string;
  titleLabel: string;
  messageLabel: string;
  isErrored?: boolean;
  dataTestId?: string;
};
export const EditMyCriteriaPopin = ({
  onCloseModal,
  onClickCancel,
  onClickConfirm,
  mainIconName,
  cancelLabel,
  confirmLabel,
  titleLabel,
  messageLabel,
  isErrored = false,
  dataTestId = 'EditMyCriteriaPopin',
}: EditMyCriteriaPopinPropsType) => {
  const textColor = isErrored ? 'text-red' : 'text-black';
  return (
    <Modal className="overflow-hidden p-20" onClose={onCloseModal} size="small">
      <div className="flex flex-col items-center p-30" data-testid={dataTestId}>
        <div className="flex flex-1 pb-10">
          <Icon className={textColor} name={mainIconName} width="5em" />
        </div>
        <div className="flex flex-1 pb-10">
          <Text className={`text-20 font-bold ${textColor}`} text={titleLabel} />
        </div>
        <div className="flex flex-2 pb-10">
          <Text className={`text-center text-12 ${textColor}`} text={messageLabel} />
        </div>
        <div className="flex w-full flex-1 justify-evenly">
          {!!onClickCancel && (
            <Button data-testid="modal-criteria-cancel-button" onClick={onClickCancel} theme="link">
              {cancelLabel}
            </Button>
          )}
          <Button
            isDisabled={false} //add condition to disable validate if necessary towdow
            data-testid="modal-criteria-validation-button"
            onClick={onClickConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
